import { useRef, useEffect } from "react"
import axios, { CancelTokenSource } from 'axios';

const useCancelableRequest = () => {
  const cancelTokens = useRef<Map<string, CancelTokenSource>>(new Map());

  const getCancelToken = (key: string) => {

    if (cancelTokens.current.has(key)) {
      const existingToken = cancelTokens.current.get(key);
      existingToken?.cancel(`Operation canceled for key: ${key}`);
    }

    const newToken = axios.CancelToken.source();
    cancelTokens.current.set(key, newToken);

    return newToken;
  };

  useEffect(() => {
    return () => {
      cancelTokens.current.forEach((token, key) => {
        token.cancel(`Component unmounted, request for key: ${key} canceled.`);
      });
      cancelTokens.current.clear(); 
    };
  }, []);

   return getCancelToken;
}

export default useCancelableRequest;
